export const staticYears = [
  { id: 2019, value: 2019 },
  { id: 2018, value: 2018 }
]

//Multiplier to calculate bushels using cattle headcount
export const DAIRY_MULTIPLIER = 104
export const BEEF_MULTIPLIER = 60